import { render, staticRenderFns } from "./ekiosk-users.vue?vue&type=template&id=676d81de&"
import script from "./ekiosk-users.vue?vue&type=script&lang=js&"
export * from "./ekiosk-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports